module.exports = __webpack_public_path__ + "static/media/no-internet.991bad53.png";